var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInclinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "22px",
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_inclinic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19 0 19 21.6887465 0 21.6887465"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Video-Visit-5",
    transform: "translate(-597.000000, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_inclinic",
    transform: "translate(597.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,1.97965336 C11.6969018,1.97965336 13.484318,3.76706957 13.484318,5.96397138 C13.484318,8.16087319 11.6969018,9.9482894 9.5,9.9482894 C7.30309819,9.9482894 5.51568198,8.16087319 5.51568198,5.96397138 C5.51568198,3.76706957 7.30309819,1.97965336 9.5,1.97965336 M13.8017436,10.0842347 C14.8285923,9.01218089 15.4641034,7.56198812 15.4641034,5.96397138 C15.4641034,2.67521795 12.7884235,-0.00013198569 9.5,-0.00013198569 C6.21157653,-0.00013198569 3.53589663,2.67521795 3.53589663,5.96397138 C3.53589663,7.56198812 4.17140773,9.01218089 5.1982564,10.0842347 C2.23451773,10.6979681 0,13.328113 0,16.4710222 L0,20.6988538 C0,21.2459345 0.443141954,21.6887465 0.989892675,21.6887465 C1.5366434,21.6887465 1.97978535,21.2459345 1.97978535,20.6988538 L1.97978535,16.4710222 C1.97978535,13.9659338 4.01797437,11.9280747 6.52306276,11.9280747 L12.4769372,11.9280747 C14.9820256,11.9280747 17.0202147,13.9659338 17.0202147,16.4710222 L17.0202147,18.3181619 C17.0202147,19.0849988 16.3959223,19.7089611 15.6287555,19.7089611 L4.52578931,19.7089611 C3.97936855,19.7089611 3.53589663,20.1521031 3.53589663,20.6988538 C3.53589663,21.2459345 3.97936855,21.6887465 4.52578931,21.6887465 L15.6287555,21.6887465 C17.487774,21.6887465 19,20.1765204 19,18.3181619 L19,16.4710222 C19,13.328113 16.7654823,10.6979681 13.8017436,10.0842347",
    id: "Fill-1",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInclinic);
export default __webpack_public_path__ + "static/media/icon_inclinic.c20ae85bf4bc8db3caaecd0814bada7f.svg";
export { ForwardRef as ReactComponent };